export default {"src":"/_next/static/media/platform_diagram.91bd0d0c.svg","height":300,"width":414};